import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { Resposta } from 'unb-questionario-componente';
import { Inscricao } from '../inscricao/inscricao';
import { InscricaoService } from '../inscricao/inscricao.service';


@Component({
  selector: 'inscricao-professor',
  templateUrl: './inscricao-professor.component.html',
  styleUrls: [ './inscricao-professor.component.css' ]
})
export class InscricaoProfessorComponent implements OnInit {
    @Input() inscricao:Inscricao;
    @Input() ehAdmin:boolean = false;
    @Output() inscricaoOutput: EventEmitter<Inscricao> = new EventEmitter<Inscricao>();

    public isLoading: boolean;
    public resposta: Resposta;
    public botaoSalvar: boolean;
    public mensagemTela: string;


    constructor(private route: ActivatedRoute,
      private inscricaoService: InscricaoService,
      private mensagem: MatSnackBar,
      private respostaService: RespostaListaDinamicaService)  {
    }

    ngOnInit(){
      if(this.inscricao.respostaQuestionario){
        this.carregaResposta(this.inscricao.respostaQuestionario);
      }else{
        this.controlaBotaoSalvar();
      }
    }

    private carregaResposta(idRespostaQuestionario: number){
      this.isLoading = true;
        this.respostaService.getRespostaCompletaPorPergunta(idRespostaQuestionario).subscribe(
          (result:Resposta) =>{
            this.resposta = result;
            this.controlaBotaoSalvar();
            this.isLoading = false;
          },
          error =>  this.erro(error)
        );
    }


    public respostaQuestionarioEmitida(event: Resposta){
      this.resposta = event;
      if(!this.inscricao.respostaQuestionario){ // se jah existir, nao preciso ir lah e fazer update.
        this.inscricao.respostaQuestionario = event.id;
        this.isLoading = true;
        this.mensagemTela = null;
        this.inscricaoService.update(this.inscricao).subscribe(
          result => {
            this.inscricao = result;
            this.mensagemTela = "Inscrição realizada com sucesso!";
            this.controlaBotaoSalvar();
            this.inscricaoOutput.emit(this.inscricao);
            this.isLoading = false;
          },
          error => {
            this.erro(error);
          }
        );
      }
    }

    public controlaBotaoSalvar(){
      this.botaoSalvar = this.inscricaoService.controlaBotaoSalvar(this.inscricao, this.ehAdmin);
    }

    public getParametroInicializador(){
      return this.inscricao.periodo.toString();
    }

    // mostra erros na tela
   erro(erro: string){
       this.mensagem.open(erro, 'X', {duration: 5000});
       this.isLoading =false;
   }






}
